// =============================================================================
// Permissions
// =============================================================================
// All permissions as a const array (useful for iteration and validation)
export const ALL_PERMISSIONS = [
    'system:full_access',
    'system:manage_admins',
    'system:view_all_orgs',
    'portfolio:read',
    'portfolio:manage',
    'portfolio:reports',
    'org:read',
    'org:update',
    'org:delete',
    'org:manage_users',
    'org:manage_roles',
    'billing:read',
    'billing:manage',
    'property:read',
    'property:create',
    'property:update',
    'property:manage_settings',
    'property:manage_integrations',
    'property:manage_widget',
    'chat:read',
    'chat:takeover',
    'chat:release',
    'chat:delete_sessions',
    'kb:read',
    'kb:create',
    'kb:update',
    'kb:delete',
    'kb:manage',
    'kb:trigger_scraping',
    'handover:read',
    'handover:assign',
    'handover:resolve',
    'handover:transfer',
    'campaigns:read',
    'campaigns:create',
    'campaigns:update',
    'campaigns:delete',
    'campaigns:send',
    'notifications:read',
    'notifications:create',
    'notifications:manage',
    'analytics:read',
    'analytics:export',
    'analytics:cross_property',
    'reservations:read',
    'reservations:manage',
    'brand:read',
    'brand:update',
    'brand:manage',
    'channels:manage',
    'automation:manage',
    'users:read',
    'users:invite',
    'users:update',
    'users:remove',
    'users:manage_roles',
];
